import { Auth } from "@aws-amplify/auth";

export default async function logOut() {
  await Auth.signOut();
  window.location.reload();
}
